import React, { useContext } from 'react';

import Inputs from 'components/Inputs';
import V5GadgetFormContext from 'contexts/V5GadgetFormContext';

import Label from '../Label';
import { InputWrapper } from '../styles';

const ReverseAxesInput = () => {
  const { reverseAxes, setReverseAxes, draftChart } =
    useContext(V5GadgetFormContext);

  if (draftChart && draftChart.gadgetType === 'matrix') {
    return (
      <InputWrapper>
        <Label>Reverse axes</Label>
        <Inputs.Toggle value={!!reverseAxes} onChange={setReverseAxes} />
      </InputWrapper>
    );
  }
  return null;
};

export default ReverseAxesInput;
